<template>
  <edit-modal :class="{ 'is-active': isActive }">
    <div v-if="params">
      <p><b>Dossier:</b> {{ params.titel }}</p>
      <p><b>Dossiernr:</b> {{ params.nr }}</p>

      <hr>

      <div
        v-if="params.exists"
        class="notification is-warning"
      >
        Dit dossier bestaat reeds. Het bestaande dossier wordt overschreven wanneer u dit dossier uploadt.
      </div>

      <div class="field">
        <div class="control">
          <label class="checkbox">
            <input
                name="concept"
                type="checkbox"
                v-model="concept"
            >
            Opslaan als concept
          </label>
          <p><small>Om een bestaand dossier uit concept te halen moet het opnieuw geupload worden zonder vinkje voor concept.</small></p>
        </div>
      </div>

      <save-buttons
        @save="submit"
        @cancel="close"
      ></save-buttons>
    </div>

    <uploader
      v-else
      label="Upload Kwalificatiedossier (XML)"
      action="files/upload"
      @cancel="close"
    ></uploader>
  </edit-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Uploader from '@/components/modules/Uploader'
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  name: 'UploadDossier',

  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },

  beforeDestroy() {
    this.destroy()
  },

  data () {
    return {
      params: null,
      concept: false
    }
  },

  components: {
    Uploader,
    EditModal,
    SaveButtons
  },

  computed: {
    ...mapGetters({
      file: 'files/file'
    })
  },

  watch: {
    file () {
      if (this.file) {
        this.params = JSON.parse(this.file)
      }
    }
  },

  methods: {
    submit () {
      this.params.concept = this.concept
      this.$store.dispatch('dossiers/save', this.params)

      this.close()
    },

    close () {
      this.params = null
      this.concept = false
      this.$store.commit('files/SET_FILE', null)

      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
